function removeEmpty(
  obj: Record<string, string | number | undefined | null> | string
): Record<string, string> {
  return Object.keys(obj)
    .filter((k) => obj[k] != null)
    .reduce(
      (newObj, key) =>
        typeof obj[key] === 'object'
          ? { ...newObj, [key]: removeEmpty(obj[key]) }
          : { ...newObj, [key]: obj[key] },
      {}
    );
}

export default removeEmpty;
